<template>
    <div> 
      <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
            <v-col cols="12" class="text-center">
            <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
            <div class="mt-4 text-h6">Cargando...</div>
            </v-col>
        </v-row>

      
      <div v-else class="rounded-lg text-center">
        <div class="rounded-lg" style="background-color: rgba(63, 81, 181, 0.8); color: white;">
          <h1 class="ml-4 pt-2">Diagnóstico de Habilidades Digitales</h1>
        </div>
      </div>
  
      <!-- Instrucciones -->
      <v-card flat class="my-4 mx-4 pa-4">
        <v-card-text class="text-center ">
          <h3>{{ instructions }}</h3>
        </v-card-text>
      </v-card>
  
      <!-- Tabs para las secciones -->
      <v-tabs v-model="currentTab" grow color="deep-purple">
        <v-tab v-for="(sectionName, index) in sectionNames" :key="index">
          <v-icon left>mdi-format-list-checks</v-icon>
          {{ sectionName }}
        </v-tab>
      </v-tabs>
      
     
      <!-- Contenido de las tabs -->
      <v-tabs-items  v-model="currentTab" touchless>
        <!-- Sección 1: Datos generales -->
        <v-tab-item :key="0">
          <v-card flat>
            <v-card class="mb-6">
              <v-divider></v-divider>
              <div v-for="(question, index) in questionsBySection[0]" :key="index" class="pa-4">
                <v-card class="mt-4 pa-2">
                  <v-card-title class="white--text book-paragraph primary d-flex">
                    <div>
                      <v-icon left color="white">mdi-comment-question</v-icon>
                      <span>{{ `Pregunta ${index + 1}: ${question.text}` }}</span>
                    </div>
                  </v-card-title>
  
                  <v-card-text>
                    <!-- Single Choice (Sexo) -->
                    <v-container v-if="question.type === 'single_choice'" class="d-flex">
                      <v-radio-group disabled>
                        <v-radio
                          v-for="option in question.options"
                          :key="`option-${question.id}-${option.id}`"
                          :value="option.id"
                          color="success"
                          disabled
                          class="pa-2"
                        >
                          <template v-slot:label>
                            <span class="px-2">{{ option.text }}</span>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </v-container>
  
                    <!-- Multiple Choice (Equipos) -->
                    <v-container v-if="question.type === 'multiple_choice'" class="options-container">
                      <v-checkbox
                        v-for="option in question.options"
                        :key="`moption-${question.id}-${option.id}`"
                        :label="option.text"
                        :value="option.id"
                        disabled
                        color="success"
                        class="custom-checkbox"
                      >
                      </v-checkbox>
                    </v-container>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
          </v-card>
        </v-tab-item>
  
        <!-- Sección 2: Habilidades digitales -->
        <v-tab-item :key="1">
          <v-card flat>
            <v-card class="mb-6">
              <v-divider></v-divider>
              <div v-for="(question, index) in questionsBySection[1]" :key="index" class="pa-4">
                <v-card class="mt-4 pa-2">
                  <v-card-title class="white--text book-paragraph primary d-flex">
                    <div>
                      <v-icon left color="white">mdi-comment-question</v-icon>
                      <span>{{ `Pregunta ${index + 1}: ${question.text}` }}</span>
                    </div>
                  </v-card-title>
  
                  <v-card-text>
                    <v-radio-group disabled>
                      <v-radio
                        v-for="option in question.options"
                        :key="`option-${question.id}-${option.id}`"
                        :value="option.id"
                        color="success"
                        disabled
                        class="pa-2"
                      >
                        <template v-slot:label>
                          <span class="px-2">{{ option.text }}</span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </div>
            </v-card>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        questionsBySection: [],
        instructions: "",
        currentTab: 0,
        sectionNames: ["Datos Generales", "Habilidades Digitales"],
        loading: true
      };
    },
    methods: {
      async loadQuestions() {
        try {
          const response = await axios.get('/questionHabilidadesDigitales');
          this.questionsBySection = response.data.questionsBySection;
          this.instructions = response.data.instructions;
          this.loading = false;
        } catch (error) {
          console.error('Error cargando preguntas de habilidades:', error);
          this.$swal('Error', 'No se pudieron cargar las preguntas', 'error');
        }
      }
    },
    async created() {
      await this.loadQuestions();
    }
  };
  </script>